export const category = [
  {
    id: 1,
    category: "protein",
  },

  {
    id: 2,
    category: "gainer",
  },

  {
    id: 3,
    category: "creatine",
  },

  {
    id: 4,
    category: "multivitamin",
  },
];
